import * as ko from "knockout";
import Bao from "./../../services/bao-service";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-searcher";
function ExpandedSearchTicket(parent) {
    var self = this;
    var htmlUrl = "ExpandedSearchSynoset/ExpandedTicket";
    self.LoadHtml = function () {
        return Bao.get(htmlUrl, function (result) {
            Bao.Templates[htmlUrl] = result;
            parent.ExpandedSearchTemplateName(htmlUrl);
        });
    };
    self.Status = ko.observable();
    self.TicketStatusId = ko.observable();
    self.TicketStatusId.subscribe(function () {
        parent.CustomFilter(self.GetCustomFilter());
    });
    self.GetCustomFilter = function () {
        if (self.TicketStatusId() == null) {
            return null;
        }
        else {
            return {
                TicketStatusId: JSON.stringify(self.TicketStatusId())
            };
        }
    };
    self.init = function () {
        return self.LoadHtml();
    };
}
export default ExpandedSearchTicket;